module.exports = __webpack_public_path__ + "icon-twitter@2x.png?16278735f41c5de0eeb861855b8ef189";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-twitter@2x.png
// module id = 210
// module chunks = 0